import {
  compactSearchText,
  SEARCH_WHITESPACE_REGEX,
  splitSearchWords,
} from '~/chords/Select/components/DropdownSingleSelect/constants';
import { foldSearchText } from '~/chords/Select/components/DropdownSingleSelect/utils/foldSearchText';

/**
 * Query tokens: split words, compacted joiner-chunks ("hiphop" from
 * "hip-hop"), and the original whitespace-chunks so a typed "/" or ":"
 * is still searchable. Spaces stay as term breaks.
 */
export function getSearchMatchTokens(value: string): string[] {
  const folded = foldSearchText(value);
  const words = splitSearchWords(folded);
  const rawChunks = folded.split(SEARCH_WHITESPACE_REGEX).filter(Boolean);
  const compactedChunks = rawChunks.map(compactSearchText).filter(Boolean);

  return [...new Set([...words, ...compactedChunks, ...rawChunks])];
}
